module.exports = __webpack_public_path__ + "img/mot_autoriza.8d5880fd.png";